import { useState } from "react";
import { useAppState } from "../AppState";
import { postUnemploymentApplication, postWorkIncapacityApplication, postHospitalisedApplication, postUpdateClaimApplication } from "../api";

function FixDateString(inString) {
    if (inString) {
        return new Date(inString).toJSON();
    }
}


const useComposeApplication = () => {
    const [
        {
            formValues,
        },
    ] = useAppState();

    const [loading, setLoading] = useState(false);

    const composeApplicationUnemployment = () => {
        var formData = new FormData();
        formData.append('email', formValues.step1.email);
        formData.append('name', formValues.step1.name);

        formData.append('employmentStartDate', FixDateString(formValues.unemploymentForm.employmentStartDate));
        formData.append('workFullTime', formValues.unemploymentForm.workFullTime);
        formData.append('hoursPerWeek', formValues.unemploymentForm.hoursPerWeek);
        formData.append('employmentStopNotice', FixDateString(formValues.unemploymentForm.employmentStopNotice));
        formData.append('employmentStopDate', FixDateString(formValues.unemploymentForm.employmentStopDate));

        formData.append('employmentStopReason', formValues.unemploymentForm.employmentStopReason);
        formData.append('typeOfEmployment', formValues.unemploymentForm.typeOfEmployment);
        formData.append('activeSearch', formValues.unemploymentForm.activeSearch);
        formData.append('selfEmployed', formValues.unemploymentForm.selfEmployed);

        if (formValues.unemploymentForm.employerCertFile) {
            if (formValues.unemploymentForm.employerCertFile.length > 0) {
                for (let x = 0; x < formValues.unemploymentForm.employerCertFile.length; x++) {
                    // the name has to be 'files' so that .NET could properly bind it
                    formData.append('employerCertFile', formValues.unemploymentForm.employerCertFile.item(x));
                }
            }
            //formData.append('employerCertFile', formValues.unemploymentForm.employerCertFile, formValues.unemploymentForm.employerCertFile.name);
        }
        if (formValues.unemploymentForm.unemploymentCertFile) {
            if (formValues.unemploymentForm.unemploymentCertFile.length > 0) {
                for (let x = 0; x < formValues.unemploymentForm.unemploymentCertFile.length; x++) {
                    // the name has to be 'files' so that .NET could properly bind it
                    formData.append('unemploymentCertFile', formValues.unemploymentForm.unemploymentCertFile.item(x));
                }
            }
            //formData.append('employerCertFile', formValues.unemploymentForm.employerCertFile, formValues.unemploymentForm.employerCertFile.name);
        }

        if (formValues.unemploymentForm.benefitsCertFile) {
            if (formValues.unemploymentForm.benefitsCertFile.length > 0) {
                for (let x = 0; x < formValues.unemploymentForm.benefitsCertFile.length; x++) {
                    // the name has to be 'files' so that .NET could properly bind it
                    formData.append('benefitsCertFile', formValues.unemploymentForm.benefitsCertFile.item(x));
                }
            }
            //formData.append('benefitsCertFile', formValues.unemploymentForm.benefitsCertFile, formValues.unemploymentForm.benefitsCertFile.name);
        }
        if (formValues.unemploymentForm.terminationCertFile) {
            if (formValues.unemploymentForm.terminationCertFile.length > 0) {
                for (let x = 0; x < formValues.unemploymentForm.terminationCertFile.length; x++) {
                    // the name has to be 'files' so that .NET could properly bind it
                    formData.append('terminationCertFile', formValues.unemploymentForm.terminationCertFile.item(x));
                }
            }
            //formData.append('terminationCertFile', formValues.unemploymentForm.terminationCertFile, formValues.unemploymentForm.terminationCertFile.name);
        }
        return formData;

    };

    const composeApplicationWorkIncapacity = () => {
        var formData = new FormData();
        formData.append('email', formValues.step1.email);
        formData.append('name', formValues.step1.name);

        formData.append('conditionStartDate', FixDateString(formValues.workIncapacityForm.conditionStartDate));
        formData.append('description', formValues.workIncapacityForm.description);
        formData.append('doctorNameEmail', formValues.workIncapacityForm.doctorNameEmail);
        formData.append('doctorNoticeDate', FixDateString(formValues.workIncapacityForm.doctorNoticeDate));

        formData.append('firstSickLeaveDate', FixDateString(formValues.workIncapacityForm.firstSickLeaveDate));
        formData.append('lastSickLeaveDate', FixDateString(formValues.workIncapacityForm.lastSickLeaveDate));

        if (formValues.workIncapacityForm.sickLeaveCertFile) {
            if (formValues.workIncapacityForm.sickLeaveCertFile.length > 0) {
                for (let x = 0; x < formValues.workIncapacityForm.sickLeaveCertFile.length; x++) {
                    formData.append('sickLeaveCertFile', formValues.workIncapacityForm.sickLeaveCertFile.item(x));
                }
            }
        }
        if (formValues.workIncapacityForm.socialSecurityCertFile) {
            for (let x = 0; x < formValues.workIncapacityForm.socialSecurityCertFile.length; x++) {
                formData.append('socialSecurityCertFile', formValues.workIncapacityForm.socialSecurityCertFile.item(x));
            }
        }
        if (formValues.workIncapacityForm.employerCertFile) {
            for (let x = 0; x < formValues.workIncapacityForm.employerCertFile.length; x++) {
                formData.append('employerCertFile', formValues.workIncapacityForm.employerCertFile.item(x));
            }
        }

        if (formValues.workIncapacityForm.medicalCertFile) {
            for (let x = 0; x < formValues.workIncapacityForm.medicalCertFile.length; x++) {
                formData.append('medicalCertFile', formValues.workIncapacityForm.medicalCertFile.item(x));
            }
        }

        if (formValues.workIncapacityForm.medicalJournalFile) {
            for (let x = 0; x < formValues.workIncapacityForm.medicalJournalFile.length; x++) {
                formData.append('medicalJournalFile', formValues.workIncapacityForm.medicalJournalFile.item(x));
            }
        }

        formData.append('typeSelector', formValues.workIncapacityForm.typeSelector);
        formData.append('accidentLocation', formValues.workIncapacityForm.accidentLocation);

        return formData;
    };

    const composeApplicationHospitalised = () => {

        var formData = new FormData();
        formData.append('email', formValues.step1.email);
        formData.append('name', formValues.step1.name);

        formData.append('typeSelector', formValues.hospitalisedForm.typeSelector);
        formData.append('description', formValues.hospitalisedForm.description);
        formData.append('doctorNameEmail', formValues.hospitalisedForm.doctorNameEmail);
        formData.append('conditionStartDate', FixDateString(formValues.hospitalisedForm.conditionStartDate));
        formData.append('doctorHiredDate', FixDateString(formValues.hospitalisedForm.doctorHiredDate));

        if (formValues.hospitalisedForm.medicalCertFile) {
            for (let x = 0; x < formValues.hospitalisedForm.medicalCertFile.length; x++) {
                formData.append('medicalCertFile', formValues.hospitalisedForm.medicalCertFile.item(x));
            }
        }

        if (formValues.hospitalisedForm.medicalJournalFile) {
            for (let x = 0; x < formValues.hospitalisedForm.medicalJournalFile.length; x++) {
                formData.append('medicalJournalFile', formValues.hospitalisedForm.medicalJournalFile.item(x));
            }
        }

        formData.append('otherBenefitsDate', FixDateString(formValues.hospitalisedForm.otherBenefitsDate));
        formData.append('accidentLocation', formValues.hospitalisedForm.accidentLocation);
        formData.append('firstDayInHospitalDate', FixDateString(formValues.hospitalisedForm.firstDayInHospitalDate));
        formData.append('lastDayInHospitalDate', FixDateString(formValues.hospitalisedForm.lastDayInHospitalDate));
        formData.append('socialSecurityCity', formValues.hospitalisedForm.socialSecurityCity);

        return formData;
    };

    const composeApplicationUnemploymentUpdate = (formValues) => {
        var formData = new FormData();
        formData.append('claimEventId', formValues.claimEventId);
        formData.append('email', formValues.email);

        if (formValues.employerCertFile) {
            if (formValues.employerCertFile.length > 0) {
                for (let x = 0; x < formValues.employerCertFile.length; x++) {
                    formData.append('employerCertFile', formValues.employerCertFile.item(x));
                }
            }
        }
        if (formValues.unemploymentCertFile) {
            if (formValues.unemploymentCertFile.length > 0) {
                for (let x = 0; x < formValues.unemploymentCertFile.length; x++) {
                    // the name has to be 'files' so that .NET could properly bind it
                    formData.append('unemploymentCertFile', formValues.unemploymentCertFile.item(x));
                }
            }
            //formData.append('employerCertFile', formValues.unemploymentForm.employerCertFile, formValues.unemploymentForm.employerCertFile.name);
        }
        if (formValues.benefitsCertFile) {
            if (formValues.benefitsCertFile.length > 0) {
                for (let x = 0; x < formValues.benefitsCertFile.length; x++) {
                    formData.append('benefitsCertFile', formValues.benefitsCertFile.item(x));
                }
            }
        }
        if (formValues.terminationCertFile) {
            if (formValues.terminationCertFile.length > 0) {
                for (let x = 0; x < formValues.terminationCertFile.length; x++) {
                    formData.append('terminationCertFile', formValues.terminationCertFile.item(x));
                }
            }
        }
        return formData;
    };

    const composeApplicationWorkIncapacityUpdate = (formValues) => {

        var formData = new FormData();
        formData.append('claimEventId', formValues.claimEventId);
        formData.append('email', formValues.email);

        if (formValues.sickLeaveCertFile) {
            if (formValues.sickLeaveCertFile.length > 0) {
                for (let x = 0; x < formValues.sickLeaveCertFile.length; x++) {
                    formData.append('sickLeaveCertFile', formValues.sickLeaveCertFile.item(x));
                }
            }
        }
        if (formValues.socialSecurityCertFile) {
            for (let x = 0; x < formValues.socialSecurityCertFile.length; x++) {
                formData.append('socialSecurityCertFile', formValues.socialSecurityCertFile.item(x));
            }
        }
        if (formValues.employerCertFile) {
            for (let x = 0; x < formValues.employerCertFile.length; x++) {
                formData.append('employerCertFile', formValues.employerCertFile.item(x));
            }
        }
        if (formValues.medicalCertFile) {
            for (let x = 0; x < formValues.medicalCertFile.length; x++) {
                formData.append('medicalCertFile', formValues.medicalCertFile.item(x));
            }
        }

        if (formValues.medicalJournalFile) {
            for (let x = 0; x < formValues.medicalJournalFile.length; x++) {
                formData.append('medicalJournalFile', formValues.medicalJournalFile.item(x));
            }
        }

        //if (formValues.sickLeaveCertFile)
        //    formData.append('sickLeaveCertFile', formValues.sickLeaveCertFile, formValues.sickLeaveCertFile.name);
        //if (formValues.socialSecurityCertFile)
        //    formData.append('socialSecurityCertFile', formValues.socialSecurityCertFile, formValues.socialSecurityCertFile.name);
        //if (formValues.employerCertFile)
        //    formData.append('employerCertFile', formValues.employerCertFile, formValues.employerCertFile.name);
        return formData;
    };

    const composeApplicationHospitalisedUpdate = (formValues) => {
        var formData = new FormData();
        formData.append('claimEventId', formValues.claimEventId);
        formData.append('email', formValues.email);

        if (formValues.medicalCertFile) {
            for (let x = 0; x < formValues.medicalCertFile.length; x++) {
                formData.append('medicalCertFile', formValues.medicalCertFile.item(x));
            }
        }

        if (formValues.medicalJournalFile) {
            for (let x = 0; x < formValues.medicalJournalFile.length; x++) {
                formData.append('medicalJournalFile', formValues.medicalJournalFile.item(x));
            }
        }

        //if (formValues.medicalCertFile)
        //    formData.append('medicalCertFile', formValues.medicalCertFile, formValues.medicalCertFile.name);

        return formData;
    };



    const send = async (applicationType) => {
        try {
            setLoading(true);
            if (applicationType == 1) {
                //Unemployment                
                const application = composeApplicationUnemployment();
                const response = await postUnemploymentApplication(application);
                return response;
            } else if (applicationType == 2) {
                //Workincapacity
                const application = composeApplicationWorkIncapacity();
                const response = await postWorkIncapacityApplication(application);
                return response;
            } else if (applicationType == 3) {
                //Hospitalised
                const application = composeApplicationHospitalised();
                const response = await postHospitalisedApplication(application);
                return response;
            }
        } catch (error) {
            return null;
        } finally {
            setLoading(false);
        }
    };
    const update = async (updateType, formData) => {
        try {
            setLoading(true);
            if (updateType == 2) {
                //Unemployment                
                const application = composeApplicationUnemploymentUpdate(formData);
                const response = await postUpdateClaimApplication(application, `/UpdateApplication/UpdateApplicationUnemployment`);
                return response;
            } else if (updateType == 1) {
                //Workincapacity
                const application = composeApplicationWorkIncapacityUpdate(formData);
                const response = await postUpdateClaimApplication(application, `/UpdateApplication/UpdateApplicationWorkIncapacity`);
                return response;
            } else if (updateType == 5) {
                //Hospitalised
                const application = composeApplicationHospitalisedUpdate(formData);
                const response = await postUpdateClaimApplication(application, `/UpdateApplication/UpdateApplicationHospitalised`);
                return response;
            }
        } catch (error) {
            return null;
        } finally {
            setLoading(false);
        }
    };

    return {
        send,
        loading,
        update
    };
};

export default useComposeApplication;
